/* GEN THEORY mağaza yardımcıları: ürün verisi, fiyat, sepete ekleme, menü, sepet paneli (öneriler, kargo ve 3 al 2 öde ilerlemesi). */
(function () {
  var GT = window.GT = window.GT || {};
  GT.p = GT.p || {};
  function norm(t) { return String(t || '').toLocaleLowerCase('tr').replace(/\s+/g, ' ').trim(); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  GT.money = function (cents) {
    var v = cents / 100;
    return '₺' + v.toLocaleString('tr-TR', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };
  GT.find = function (name) {
    if (GT.p[name]) return GT.p[name];
    var n = norm(name);
    for (var h in GT.p) if (norm(GT.p[h].t) === n) return GT.p[h];
    var w = n.split(' '), best = null, bs = 0;
    for (var h2 in GT.p) {
      var tw = norm(GT.p[h2].t).split(' '), hit = 0;
      w.forEach(function (x) { if (tw.indexOf(x) >= 0) hit++; });
      var sc = hit / Math.max(w.length, tw.length);
      if (sc > bs) { bs = sc; best = GT.p[h2]; }
    }
    return bs >= 0.6 ? best : null;
  };
  GT.price = function (name, qty) { var p = GT.find(name); return p ? GT.money(p.pr * (qty || 1)) : ''; };
  GT.url = function (name) { var p = GT.find(name); return p ? p.u : '/collections/all'; };

  var lockY = 0;
  function lock(on) {
    if (on) { lockY = window.scrollY; document.body.style.overflow = 'hidden'; }
    else if (!document.querySelector('#gt-menu.on, #gt-cart.on')) { document.body.style.overflow = ''; }
  }

  /* ---------- menü ---------- */
  function menu(open) {
    var m = document.getElementById('gt-menu');
    if (!m) return;
    m.classList.toggle('on', open);
    m.setAttribute('aria-hidden', open ? 'false' : 'true');
    lock(open);
  }
  GT.menu = menu;

  /* ---------- sepet ---------- */
  var cartEl, cart = null, busy = false;
  function thr() { return (parseInt((GT.s && GT.s.freeShip) || '750', 10) || 750) * 100; }
  function info(title) {
    var c = (GT.C && GT.C[title]) || null;
    if (!c) { var p = GT.find(title); if (p && GT.C) c = GT.C[p.t]; }
    var t = c && GT.T ? GT.T[c.t] : null;
    return { c: c, t: t };
  }
  function itemHTML(it) {
    var I = info(it.product_title), t = I.t;
    var disc = it.original_line_price - it.final_line_price;
    return '<div class="gk-it" data-key="' + esc(it.key) + '">' +
      '<a class="im" href="' + esc(it.url) + '"><img src="' + esc(it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '') + '" alt=""></a>' +
      '<div><div class="no">' + (t ? '<i style="background:' + t.c + '"></i>Nº' + t.n + ' · ' + t.th : '') + (I.c ? ' · ' + I.c.fmt : '') + '</div>' +
      '<a class="nm" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
      '<div class="rw"><div class="gk-q"><button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Azalt">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + (it.quantity + 1) + '" aria-label="Artır">+</button></div>' +
      '<div class="pr">' + (disc > 0 ? '<s>' + GT.money(it.original_line_price) + '</s>' : '') + GT.money(it.final_line_price) + (disc > 0 ? '<em>3 AL 2 ÖDE</em>' : '') + '</div></div>' +
      '<button type="button" class="gk-rm" data-q="0">KALDIR</button></div></div>';
  }
  function recs(c) {
    if (!GT.C) return [];
    var inCart = {}, themes = {}, fmts = {};
    (c.items || []).forEach(function (it) {
      inCart[norm(it.product_title)] = 1;
      var I = info(it.product_title);
      if (I.c) { themes[I.c.t] = 1; fmts[I.c.t + '|' + I.c.fmt] = 1; }
    });
    var out = [];
    Object.keys(GT.C).forEach(function (name) {
      if (inCart[norm(name)]) return;
      var c2 = GT.C[name], sc = 0, why = '';
      if (themes[c2.t] !== undefined) { sc += 10; why = GT.T[c2.t].th + ' RUTİNİNİ TAMAMLA'; }
      if (c2.fmt === 'GÖZ KREMİ') sc += 3;
      if (name === 'Caviar PDRN Göz Kremi') sc += 2;
      if (name === 'Heartleaf 77 Pore Toner' || name === 'Jeju Matcha BHA Kil Çubuk') sc += 1;
      if (!why) why = 'Nº' + GT.T[c2.t].n + ' · ' + c2.fmt;
      var p = GT.find(name);
      if (p) out.push({ name: name, sc: sc, why: why, p: p, c: c2 });
    });
    out.sort(function (a, b) { return b.sc - a.sc; });
    return out.slice(0, 3);
  }
  function render() {
    if (!cartEl || !cart) return;
    var c = cart, n = c.item_count, T = thr();
    cartEl.querySelector('[data-n]').textContent = n;
    var left = Math.max(0, T - c.total_price), rem = n % 3, freeN = Math.floor(n / 3);
    var bx = n === 0 ? 'HER 3 ÜRÜNDE 1 BEDAVA' : rem === 2 ? '<b>1 ÜRÜN DAHA</b> EKLE, 1\'İ BEDAVA' : rem === 1 ? '<b>2 ÜRÜN DAHA</b> EKLE, 3.\'SÜ BEDAVA' : '<b>3 AL 2 ÖDE</b> UYGULANDI · ' + freeN + ' BEDAVA';
    cartEl.querySelector('[data-prog]').innerHTML =
      '<div class="row"><div class="lb"><span>' + (left > 0 ? 'KARGO BEDAVAYA <b>' + GT.money(left) + '</b> KALDI' : '<b>KARGO BEDAVA</b>') + '</span><span>' + GT.money(T) + '</span></div><div class="bar"><i style="width:' + Math.min(100, c.total_price / T * 100) + '%"></i></div></div>' +
      '<div class="row"><div class="lb"><span>' + bx + '</span><span>3 AL 2 ÖDE</span></div><div class="cells"><i class="' + (rem >= 1 || (n && !rem) ? 'on' : '') + '"></i><i class="' + (rem >= 2 || (n && !rem) ? 'on' : '') + '"></i><i class="' + (n && !rem ? 'on' : '') + '"></i></div></div>';
    cartEl.querySelector('[data-items]').innerHTML = n ? c.items.map(itemHTML).join('') :
      '<div class="gk-empty"><div class="t">SEPETİN BOŞ</div><p>Derdine uygun teoriyi bul ya da ürünlere göz at.</p><a href="/collections/all">ÜRÜNLERİ İNCELE</a></div>';
    var R = recs(c);
    cartEl.querySelector('[data-rec]').innerHTML = R.length ? '<div class="hd">ÖNERİLER · 추천<span></span></div><div class="tt">' + (n ? 'RUTİNİNİ TAMAMLA' : 'BAŞLAMAK İÇİN') + '</div><div class="ls">' +
      R.map(function (r) {
        var t = GT.T[r.c.t];
        return '<div class="gk-rc"><a href="' + esc(r.p.u) + '"><img src="' + esc(r.p.img) + '" alt=""></a><div><div class="no"><i style="background:' + t.c + '"></i>Nº' + t.n + ' · ' + r.c.fmt + '</div><div class="nm">' + esc(r.name) + '</div><div class="why">' + esc(r.why) + '</div></div>' +
          '<button type="button" data-add="' + r.p.v + '">EKLE<span>' + GT.money(r.p.pr) + '</span></button></div>';
      }).join('') + '</div>' : '';
    cartEl.querySelector('[data-foot]').innerHTML = n ?
      '<div class="ln"><span>ARA TOPLAM</span><span>' + GT.money(c.original_total_price) + '</span></div>' +
      (c.total_discount > 0 ? '<div class="ln d"><span>3 AL 2 ÖDE</span><span>−' + GT.money(c.total_discount) + '</span></div>' : '') +
      '<div class="ln"><span>KARGO</span><span>' + (left > 0 ? 'ÖDEMEDE' : 'BEDAVA') + '</span></div>' +
      '<div class="ln t"><span>TOPLAM</span><span>' + GT.money(c.total_price) + '</span></div>' +
      '<a class="gk-go" href="/checkout"><span class="mono" style="font-size:15px;letter-spacing:0">' + GT.money(c.total_price) + '</span><i></i><span>ÖDEMEYE GEÇ</span><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>' +
      '<div class="gk-tr"><span>GÜVENLİ ÖDEME</span><span>' + ((GT.s && GT.s.ret) || 14) + ' GÜN İADE</span><span>İLK SİPARİŞ: ' + esc((GT.s && GT.s.code) || '') + '</span></div>' : '';
  }
  function load() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cart = c; badge(c); render(); return c; });
  }
  function badge(c) {
    GT.count = c.item_count;
    document.querySelectorAll('[aria-label="Sepet"]').forEach(function (b) {
      var d = b.querySelector('.gt-cc');
      if (!c.item_count) { if (d) d.remove(); return; }
      if (!d) { d = document.createElement('span'); d.className = 'gt-cc'; b.style.position = 'relative'; b.appendChild(d); }
      d.textContent = c.item_count;
    });
    document.dispatchEvent(new CustomEvent('gt:cart', { detail: c }));
  }
  GT.badge = function () { return load(); };
  function openCart() {
    cartEl = cartEl || document.getElementById('gt-cart');
    if (!cartEl) { location.href = '/cart'; return; }
    menu(false);
    cartEl.classList.add('on'); cartEl.setAttribute('aria-hidden', 'false'); lock(true);
    load();
  }
  function closeCart() { if (!cartEl) return; cartEl.classList.remove('on'); cartEl.setAttribute('aria-hidden', 'true'); lock(false); }
  GT.openCart = openCart;
  function change(key, q) {
    if (busy) return; busy = true; cartEl.classList.add('gk-busy');
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { return r.json(); }).then(function (c) { cart = c; badge(c); render(); })
      .catch(function () {}).then(function () { busy = false; cartEl.classList.remove('gk-busy'); });
  }

  function toast(msg) {
    var t = document.getElementById('gt-toast');
    if (!t) { t = document.createElement('div'); t.id = 'gt-toast'; document.body.appendChild(t); }
    t.innerHTML = '<span>' + msg + '</span>';
    t.className = 'on';
    clearTimeout(GT._tt); GT._tt = setTimeout(function () { t.className = ''; }, 3600);
  }
  GT.toast = toast;

  // items: [{ id | name, quantity }]
  GT.add = function (items, opts) {
    var list = items.map(function (it) {
      var id = it.id || (GT.find(it.name) || {}).v;
      return { id: id, quantity: it.quantity || 1 };
    }).filter(function (x) { return x.id; });
    if (!list.length) return Promise.resolve(null);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { toast(res.description || 'Sepete eklenemedi'); return null; }
        if (opts && opts.checkout) { location.href = '/checkout'; return res; }
        if (opts && opts.cart) { location.href = '/cart'; return res; }
        if (opts && opts.silent) { load(); return res; }
        openCart();
        return res;
      });
  };

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-add]');
    if (a && cartEl && cartEl.contains(a)) { e.preventDefault(); GT.add([{ id: +a.getAttribute('data-add'), quantity: 1 }], { silent: true }); return; }
    var q = e.target.closest('[data-q]');
    if (q && cartEl && cartEl.contains(q)) { e.preventDefault(); change(q.closest('[data-key]').getAttribute('data-key'), +q.getAttribute('data-q')); return; }
    if (e.target.closest('#gt-cart [data-close]')) { e.preventDefault(); closeCart(); return; }
    var b = e.target.closest('button[aria-label]');
    if (!b) return;
    var l = b.getAttribute('aria-label');
    if (l === 'Menü') { e.preventDefault(); menu(true); }
    else if (l === 'Kapat' && b.closest('#gt-menu')) { e.preventDefault(); menu(false); }
    else if (l === 'Ara') { e.preventDefault(); menu(true); setTimeout(function () { var i = document.querySelector('#gt-menu input[name=q]'); if (i) i.focus(); }, 320); }
    else if (l === 'Sepet' || l.indexOf('Sepet,') === 0) { e.preventDefault(); openCart(); }
    else if (l === 'Geri') { e.preventDefault(); if (history.length > 1) history.back(); else location.href = '/'; }
  });
  document.addEventListener('click', function (e) { var m = e.target.closest('#gt-menu a'); if (m) menu(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { menu(false); closeCart(); } });
  function init() { cartEl = document.getElementById('gt-cart'); setTimeout(load, 500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
